<template>
  <div class="cb-session-timeout" @keydown="setFocus">
    <h2 class="cb-heading-6" id="dialog-title">Your session has expired</h2>
    <p class="cb-body-1">
      For your security, you have been signed out.
      <strong>Please sign in again</strong> to continue.
    </p>
    <div class="cb-session-timeout__btn-container">
      <a
        @click.prevent="handleSignIn"
        ref="signIn"
        tabindex="0"
        href="#"
        class="cb-button cb-button--no-outline"
        >SIGN IN</a
      >
    </div>
  </div>
</template>

<script>
/* global gtag */
import { mapActions } from 'vuex';
import focusTrapping from '../../mixins/focusTrapping';

export default {
  mounted() {
    this.$refs.signIn.focus();
    document.title = 'Cellbridge - For your security, you have been signed out. Please sign in again to continue.';
  },
  methods: {
    handleSignIn() {
      gtag('event', 'sessionTimeoutSignInClick', {
        event_label: 'sign in after session timeout',
        event_category: 'session timeout modal',
        value: 1,
      });
      this.closeModal();
      this.$router.push('/');
    },
    ...mapActions(['closeModal']),
  },
  mixins: [focusTrapping],
};
</script>

<style lang="scss" scoped>
.cb-session-timeout {
  width: 88vw;
  max-width: 430px;
  box-sizing: border-box;
  padding: 24px 24px 10px;

  .cb-heading-6 {
    margin-bottom: 12px;
  }

  .cb-body-1 {
    font-size: 18px;
    line-height: 27px;
    margin-bottom: 16px;
  }

  &__btn-container {
    display: flex;
    justify-content: flex-end;
  }

  @include desktop {
    padding: 24px 40px 10px;
  }
}
</style>
